import http, { httpV2 } from "../http";

const SettingsService = {
  get: (types) => httpV2.get(`/settings?types=${types.join(",")}`),
  set: (data) => httpV2.put(`/settings`, data),
  getPmsFields: () => httpV2.get(`/list_pms_fields`),
};

export default SettingsService;
